import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChatAdapter, Message, User } from 'ng-chat';
import { NGXLogger } from 'ngx-logger';
import { Chat, ChatMessage, ChatService, MessageService, SharedDataService, Staff, UserService } from 'orv-ui-base-lib';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../../auth/auth.service';

@Injectable()
export class OrvChatAdapter extends ChatAdapter {

    messageSubcription: Subscription;
    loggeduser: Staff;

    constructor(private logger: NGXLogger, private userService: UserService,
        private chatService: ChatService, private messageService: MessageService, private translateService: TranslateService,
        private sharedDataService: SharedDataService,
        private authService: AuthService) {
        super();

        this.sharedDataService.currentLoggedUser.subscribe(data => {this.loggeduser = data; });

    }

    listFriends(): Observable<User[]> {

        return this.chatService.getActiveUsers();
    }

    getMessageHistory(userId: any): Observable<Message[]> {
        this.logger.log('getMessageHistory');
       return this.chatService.getChatUser(userId).flatMap((data: Chat) => {
           if (data)
            return this.chatService.getMessageHistory(userId, data.msgcount);
        });
    }

    sendMessage(message: Message): void {

        this.logger.log('send message', message);
        const chatmessage = new ChatMessage(message,  'BO' + this.authService.getUuid() );
        this.chatService.sendMessage(chatmessage).subscribe(data => {
        }, ({error}) => {
			this.messageService.sendError(error, this.translateService.instant('labels.message'));
        });
    }

}
